import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class OrderDetailsByOid
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: OrderDetailsByOid.Params): Observable<OrderDetailsByOid.Result>
	{
		return this.m_queryInvoker.doQuery("OrderDetailsByOid", params);
	}
};

export namespace OrderDetailsByOid
{
	export class Params
	{
		order: string;
	};
	export interface Result
	{
		oid?: string;
		id?: string;
		deliveryState?: number;
		orderDate?: Date;
		creationUserName?: string;
		txDate?: Date;
		txStateId?: number;
		orderValue?: number;
		currencyCode?: string;
		companyName?: string;
		trackingNumbers?: TrackingNumber[];
		noInvoice?: boolean;
		costCenter1?: string;
		zbsValuelistEntry?: string;
		poId?: string;
		paymentMethodProxy?: PaymentMethodProxy;
		costCenter2?: string;
		verificationCode?: string;
		infoText?: string;
		customerInfoText?: string;
		freightageSurcharge?: number;
		items?: Item[];
		deliveryChannel?: DeliveryChannel;
		invoiceChannel?: InvoiceChannel;
	};
	export interface TrackingNumber
	{
		id?: string;
		proxyName?: string;
		trackingLink?: string;
	};
	export interface PaymentMethodProxy
	{
		isForPO?: boolean;
		name?: string;
		descr?: string;
	};
	export interface Item
	{
		orderOid?: string;
		oid?: string;
		id?: string;
		descrShort?: string;
		needsAuthorization?: boolean;
		quantityOrdered?: number;
		quantityDelivered?: number;
		quantityRemaining?: number;
		priceUnit?: string;
		price?: number;
		value?: number;
		deliveryDate?: Date;
		logisticArea?: LogisticArea;
	};
	export interface LogisticArea
	{
		name?: string;
		descr?: string;
	};
	export interface DeliveryChannel
	{
		street?: string;
		zip?: string;
		city?: string;
		phone?: string;
		email?: string;
		alternateName?: string;
	};
	export interface InvoiceChannel
	{
		street?: string;
		zip?: string;
		city?: string;
		phone?: string;
		email?: string;
		alternateName?: string;
	};
};
